// Module
var code = `<span class="cp-skeleton" ng-class="{ 'cp-skeleton--rounded': vm.rounded }" ng-style="{ width: vm.width, height: vm.height }"></span> `;
// Exports
module.exports = code;